import React from 'react';
import PropTypes from 'prop-types';
import ColumnHeading from './ColumnHeading'
import RepairRow from './RepairRow'
import classnames from 'classnames'

import '../styles/RepairList.css'
import GroupIcon from '../images/group_icon.png'
import { Typography } from '@material-ui/core';


export default class RepairList extends React.Component {

  render () {
    const {subgroup, columns, repairs, focusOnPrices} = this.props

    let columnCount = columns.length

    return (
      <div className="book-preview">
        <div className={(focusOnPrices ? ' focus-on-pricing' : '')}>
          {
            focusOnPrices
            ? <div className="gradient-fade"></div>
            : null
          }
          <div className="repair-listing-size-message">
            <Typography>Please rotate your device into landscape mode to see this preview.</Typography>
          </div>
          <table className="repair-listing">
            <tbody>
              <tr>
                <th colSpan={columnCount + 2}>
                  <div className="edition-title" style={{display: 'inline-block', width: '50%'}}>
                    {subgroup.editionTitle}
                  </div>
                  <div style={{textAlign:'right', display: 'inline-block', width: '50%'}}>
                    {subgroup.tradeName}<br/>
                    {subgroup.groupDescription}
                  </div>
                </th>
              </tr>

              <tr>
                <th className="column-label" style={{fontWeight: 'normal'}}>Repair&nbsp;#</th>
                <th className="column-label" style={{fontWeight: 'normal'}}>Description</th>
                {
                  columns.map(col => {
                    const classes = classnames('column-title', {'book-highlight': col.highlighted, 'is-not-printed': !col.printed})
                    return (
                      <th className={classes} key={col.id}>
                        <ColumnHeading column={col}/>
                      </th>
                    )
                  })
                }
              </tr>

              <tr className="subgroup-header-row">
                <td className="subgroup-code subgroup-code-desktop">{subgroup.fullCode}</td>
                <td colSpan={columnCount + 1} >
                  <table className="icon-table">
                    <tbody>
                      <tr>
                        <td><img alt="Subgroup Icon" src={GroupIcon} className='subgroup-icon'/></td>
                        <td className="subgroup-description-column">
                          <span className="subgroup-code-mobile">{subgroup.fullCode}</span>
                          {subgroup.description}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>

              {repairs.map(repair => {
                // Placeholder until prices are loaded (in the background)
                const prices = repair.prices || columns.map(col => {
                  return (
                    {
                      total:        '',
                      locked:       false,
                      columnNumber: col.number,
                    }
                  )
                })

                return (
                  <RepairRow
                    repair={repair}
                    prices={prices}
                    columns={columns}
                    displayBarcodes={subgroup.displayBarcodes}
                    displayTime={subgroup.displayTime}
                    key={repair.id}/>
                )
              })}
            </tbody>

          </table>
        </div>
      </div>
    )
  }

}


RepairList.propTypes = {
  subgroup: PropTypes.object.isRequired,
  repairs:  PropTypes.array.isRequired,
  columns:  PropTypes.array.isRequired,
  focusOnPrices:  PropTypes.bool,
}
